/**
 * Per-account product visibility.
 *
 * Some accounts are provisioned for a single product only (for example the
 * JShine operators, who should see nothing but Camera Health). Accounts that
 * are not listed here keep seeing every product.
 */

export type ProductId =
  | 'synstream-enterprise'
  | 'jshine-camera-health'
  | 'pipeline-studio'
  | 'platform-demo'
  | 'auto-monitor'

/** Accounts restricted to a subset of products, keyed by lowercased account. */
const ACCOUNT_PRODUCTS: Record<string, ProductId[]> = {
  jshine_admin: ['jshine-camera-health']
}

/** Products an account may see, or null when the account is unrestricted. */
export function getAllowedProducts(account?: string | null): ProductId[] | null {
  if (!account) return null
  return ACCOUNT_PRODUCTS[account.trim().toLowerCase()] ?? null
}

export function isProductVisible(productId: ProductId, account?: string | null): boolean {
  const allowed = getAllowedProducts(account)
  return allowed === null || allowed.includes(productId)
}

/**
 * Same check for callers holding a plain id (search entries, menu data).
 * Ids that are not products are always visible.
 */
export function isProductIdVisible(productId: string, account?: string | null): boolean {
  const allowed = getAllowedProducts(account)
  return allowed === null || (allowed as string[]).includes(productId)
}
